(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-utils/assets/atomwithsvsstorage.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-utils/assets/atomwithsvsstorage.js');
"use strict";


const {
  atom
} = jotai;
const browserStorage = svs.components.Storage.browser;
const productName = 'lyckoplatsen';
const atomWithSvSStorage = (key, initialValue, customSetter, forceNewValue) => {
  const getInitialValue = () => {
    if (typeof window !== 'undefined' && !forceNewValue) {
      const storedValue = browserStorage.get(key, productName);
      if (storedValue !== undefined) {
        return storedValue;
      }
    }
    return initialValue;
  };
  const baseAtom = atom(getInitialValue());
  const derivedAtom = atom(get => get(baseAtom), (get, set, update) => {
    let newValue = update;
    if (customSetter) {
      customSetter(get, set, update, baseAtom);
    } else if (typeof update === 'function') {
      newValue = update(get(baseAtom));
    }
    set(baseAtom, newValue);
    browserStorage.set(key, productName, newValue, 15);
  });
  return derivedAtom;
};
setGlobal('svs.lyckoplatsen.shared_utils', {
  atomWithSvSStorage
});

 })(window);